import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import SubMenu from "./SubMenu";
import "./sidebarScrollDesign.css";
import axios from "../../axios";
import { toast } from "react-toastify";
import { Modal } from "../../components/Modal";
import * as actionTypes from "../../store/actions";
import { SidebarData, profileSidebarData } from "./SidebarData";
import { useNavigate, useLocation } from 'react-router-dom';
import { HiArrowNarrowLeft } from "react-icons/hi";
import { CiSettings } from "react-icons/ci";


// icons
import { SlClose } from "react-icons/sl";
import { IconContext } from "react-icons/lib";
import { TiInfoOutline } from "react-icons/ti";
import { AiFillSetting } from "react-icons/ai";
import { RiLogoutBoxLine } from "react-icons/ri";
import { MdOutlineArrowRightAlt, MdPadding } from "react-icons/md";

const SidebarNav = styled.nav`
  width: 255px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 100ms;
  
  
  

  @media screen and (max-width: 768px) {
    // background-color: aliceblue;
    // background-image: none;
    left: ${({ sidebar }) => (sidebar ? "-100%" : "0")};
  }
`;
const SidebarWrap = styled.div`
  width: 100%;
  height: 100%;
   /* height: calc(100vh - 4px - 100px); */
  overflow-y: auto !important;
  overflow-x: hidden;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  padding-bottom: 100px; // Add significant bottom padding
  display: block; // Ensure proper display mode
   
  /* padding: 4px; */
`;



export const BannerContent = styled.div`
  width: 100%;
  height: 60px;
  margin-top: 0.5 rem;
  border-radius: 4px;
  margin-right: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
   
`;

export const BannerCity = styled.div`
  text-align: left;
  font-size: 17px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  width: 100%;
`;

export const BannerState = styled.div`
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.5;
  text-overflow: ellipsis;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
`;

export const Rating = styled.p`
  color: #878997;
  font-size: 0.8rem;
`;

export const SidebarDiv = styled.p`
  margin-top: 1rem;
`;

const Sidebar = ({ userData, sidebar, setSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();


  // This is manage for profile section sidebar also from browser back button
  var showProfileSidebar = "";

  if ((location?.pathname == '/profile') || (location?.pathname == '/changedPassword')) {
    showProfileSidebar = Cookies.get("showProfileSidebar") ? JSON.parse(Cookies.get("showProfileSidebar")) : "";
  } else {
    Cookies.remove("showProfileSidebar");
    showProfileSidebar = Cookies.get("showProfileSidebar") ? JSON.parse(Cookies.get("showProfileSidebar")) : "";
  }

  const [openDropdown, setOpenDropdown] = useState(() => {
    // Retrieve the open dropdown index from local storage on initial render
    const savedDropdown = localStorage.getItem("openDropdown");
    return savedDropdown !== null ? parseInt(savedDropdown, 10) : null;
  });

  const handleDropdownClick = (index) => {
    if (openDropdown === index) {
      setOpenDropdown(null); // Close the dropdown if clicked again
      localStorage.removeItem("openDropdown"); // Remove from local storage
    } else {
      setOpenDropdown(index); // Open the clicked dropdown
      localStorage.setItem("openDropdown", index); // Save to local storage
    }
  };

  const subadminData = JSON.parse(localStorage.getItem("userData")) || JSON.parse(sessionStorage.getItem("userData"));


  // Get modulePermission from userData
  const modulePermission = subadminData?.adminpermissions?.modules || userData?.adminpermissions?.modules || [];

  // Convert module permissions to a lookup for faster filtering
  const allowedModules = modulePermission.reduce((acc, module) => {
    if (Object.values(module.permissions).some(permission => permission === true)) {
      acc[module.moduleName] = true;
    }
    return acc;
  }, {});

  // Define module routes (matching SidebarData)
  const moduleRoutes = {
    "Dashboard": "dashboard",
    "User Management": "userManagement",
    "Skills Management": "skillsManagement",
    "Blacklist Word Manager": "blockManagement",
    "Commission Management": "commissionSettings",
    "Gigs Management": "gigsManagement",
    "Reported Gig Management": "reportedGigManagement",
    "Payment Management": "paymentManagement",
    "CMS Management": "cmsManagement",
    "Notification Management": "notificationManagement",
    "Leader board": "leaderboardManagement",
    "Ticket Management": "ticketManagement",
    "Feedback Management": "feedbackManagement"
  };

  // Filter SidebarData to only include allowed modules
  const filteredSidebarData = SidebarData.filter(item =>
    userData?.userType !== "subAdmin" || allowedModules[item.title]
  );

  return (
    <>
      {showProfileSidebar ? (
        <IconContext.Provider value={{}}>
          <SidebarNav sidebar={sidebar}>
            <SidebarWrap className="designScrollbarSide" >
              <SidebarDiv></SidebarDiv>
              {/* <div
                className="back-to-home"
                onClick={() => {
                  Cookies.set("showProfileSidebar", false, { expires: 365 });
                  navigate("/dashboard");
                  // if (adminData?.modulePermission?.length === 0) {
                  //   navigate("/dashboard");
                  // } else {
                  //   navigate(`/${adminData?.modulePermission[0]}`);
                  // }
                }}
              >
                <HiArrowNarrowLeft style={{ color: "#181818" }} />
                <span>Back to home</span>
              </div> */}

              <div
                className="back-to-home"
                onClick={() => {
                  Cookies.set("showProfileSidebar", false, { expires: 365 });

                  const adminData = JSON.parse(localStorage.getItem("userData")) || JSON.parse(sessionStorage.getItem("userData"));
                  const isSubAdmin = adminData?.userType === "subAdmin";
                  const modules = adminData?.adminpermissions?.modules || [];

                  const moduleRoutes = {
                    "Dashboard": "dashboard",
                    "User Management": "userManagement",
                    "Skills Management": "skillsManagement",
                    "Blacklist Word Manager": "blockManagement",
                    "Commission Management": "commissionSettings",
                    "Gigs Management": "gigsManagement",
                    "Reported Gig Management": "reportedGigManagement",
                    "Payment Management": "paymentManagement",
                    "CMS Management": "cmsManagement",
                    "Notification Management": "notificationManagement",
                    "Leader board": "leaderboardManagement",
                    "Ticket Management": "ticketManagement",
                    "Feedback Management": "feedbackManagement"
                  };

                  let targetRoute = "/dashboard"; // default

                  if (isSubAdmin && Array.isArray(modules)) {
                    for (const mod of modules) {
                      const hasPermission = Object.values(mod.permissions || {}).some(val => val === true);
                      const route = moduleRoutes[mod.moduleName];
                      if (hasPermission && route) {
                        targetRoute = `/${route}`;
                        break;
                      }
                    }
                  }

                  navigate(targetRoute);
                }}
              >
                <HiArrowNarrowLeft style={{ color: "#181818" }} />
                <span>Back to home</span>
              </div>

              <div style={{marginLeft: "0.3rem", marginBottom: "1rem",display: "flex",
                 alignItems: "center" , gap: "0.2rem"}}>
                 <CiSettings style={{fontSize: "1.4rem"}}/>Admin Settings</div>
              


              {profileSidebarData.map((item, index) => {
                return (
                  <SubMenu
                    item={item}
                    key={index}
                    isOpen={openDropdown === index}
                    onToggle={() => handleDropdownClick(index)}


                  />
                );
              })}
            </SidebarWrap>
          </SidebarNav>
        </IconContext.Provider>
      ) : (
        <IconContext.Provider value={{ color: "#fffff" }}>
          <SidebarNav sidebar={sidebar}>
            <SidebarWrap className="designScrollbarSide">

              {filteredSidebarData.map((item, index) => (
                <SubMenu
                  item={item}
                  key={index}
                  isOpen={openDropdown === index}
                  onToggle={() => handleDropdownClick(index)}
                />
              ))}
            </SidebarWrap>
          </SidebarNav>
        </IconContext.Provider>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);
